import { render, staticRenderFns } from "./DashboardPendingSurveysCard.vue?vue&type=template&id=5c790d7a"
import script from "./DashboardPendingSurveysCard.vue?vue&type=script&lang=js"
export * from "./DashboardPendingSurveysCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports